/**
 * The trigger and the panel live in two different corners of the shell (the top
 * bar and a floating host next to the drawers), so they cannot hand each other
 * a ref. They agree on two ids instead: `aria-controls` points at the panel,
 * and closing the panel gives the keyboard back to the trigger by id.
 */
export const COMPANION_TRIGGER_ID = 'companion-trigger';
export const COMPANION_PANEL_ID = 'companion-panel';

/** Returns the keyboard to the trigger, when there is still one on screen. */
export const focusCompanionTrigger = (): void => {
  if (typeof document === 'undefined') return;
  document.getElementById(COMPANION_TRIGGER_ID)?.focus();
};

/** Marks the conversational panel's composer, so nothing else in the panel takes its focus. */
export const COMPANION_COMPOSER_ATTRIBUTE = 'data-companion-composer';

/** Puts the keyboard in the conversational panel's composer, when the panel is open. */
export const focusCompanionComposer = (): void => {
  if (typeof document === 'undefined') return;
  document
    .querySelector<HTMLElement>(`#${COMPANION_PANEL_ID} [${COMPANION_COMPOSER_ATTRIBUTE}] textarea`)
    ?.focus();
};
